import { useState } from "react";
import { noticeItems } from "@/mocks/homeContent";

const navItems: { label: string; active?: boolean }[] = [
  { label: "首页", active: true },
  { label: "热议榜" },
  { label: "栏目分区" },
  { label: "总集归档" },
  { label: "社区广场" },
];

function Brand() {
  return (
    <a href="#top" className="flex items-center gap-2">
      <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
        <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
      </span>
      <span className="leading-none">
        <span className="font-heading block text-2xl tracking-wide text-foreground-950">
          <span className="text-primary-600">51</span>
          <span>嘿料</span>
        </span>
        <span className="mt-0.5 block text-[10px] tracking-[0.3em] text-foreground-400">NEGATIVE HUB · 总集站</span>
      </span>
    </a>
  );
}

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <header id="top" className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <Brand />

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.label}
              href="#top"
              className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                item.active
                  ? "font-medium text-foreground-950"
                  : "text-foreground-500 hover:bg-background-100 hover:text-foreground-900"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <label className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2 md:flex md:w-56">
            <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索话题 / 关键词"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </label>
          <button
            type="button"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-edit-line text-base" aria-hidden="true"></i>
            去发一帖
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col gap-1 px-4 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.label}
                href="#top"
                onClick={() => setOpen(false)}
                className={`rounded-md px-3 py-2.5 text-sm ${
                  item.active ? "font-medium text-foreground-950" : "text-foreground-600"
                }`}
              >
                {item.label}
              </a>
            ))}
            <button
              type="button"
              className="mt-1 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-edit-line mr-1.5 text-base" aria-hidden="true"></i>
              去发一帖
            </button>
          </nav>
        </div>
      )}

      <div className="relative flex items-center gap-2 overflow-hidden border-t border-background-200 bg-background-100/70 px-4 py-2">
        <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-accent-600 px-2 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-broadcast-line" aria-hidden="true"></i>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap pr-10">
            {noticeItems.map((n, idx) => (
              <span key={idx} className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-radio-button-line text-primary-500" aria-hidden="true"></i>
                {n}
              </span>
            ))}
            {noticeItems.map((n, idx) => (
              <span key={`dup-${idx}`} className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-radio-button-line text-primary-500" aria-hidden="true"></i>
                {n}
              </span>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}